import isEqual from 'lodash/isEqual'

import get from 'lodash/get'

import {
  listingsIsLoading,
  listingsLoadingMessage,
  listingsLoadMoreSuccess,
  displayInfiniteScrollLoadMore,
  updateBrandReference,
  setListingsMetaData,
} from '../actionCreators'

import { flyGaLogic } from '../../../util/flyGaLogic'
import { canLoadMoreitins } from '../../../util/canLoadMoreitins'

import { airSearch } from '../../../services/airSearch'
import {
  buildFlySearchDisplayFilterObj,
  buildFlySearchDisplayFiltersObj,
} from '../../../util/listingsHelpers'
import { flySliceSelectionStorage } from '../../../components/Legacy/fly-slice-selection-storage/fly-slice-selection-storage'
import { toggleLoadingOverlay } from '../../uiToggles'
import { handleError } from '../helpers/handleError/handleError.js'
import { getPageNumber } from '../../../util/getPageNumber'

import { airSearchRequestModel } from '../../../services/airSearch/airSearchRequest'
import { getIsSbs } from '../../../util/sbs'
/**
 * Load more itineraries and append results to existing table
 */
export function listingsLoadMore(PCLN_BOOTSTRAP_DATA, oldListings, filters) {
  return (dispatch, getState) => {
    const state = getState()
    const isSBS = getIsSbs()

    // No need to load more
    if (state.listingsHasErrored) {
      return
    }

    dispatch(toggleLoadingOverlay(true)) // Disable loading overlay while loading more
    dispatch(listingsIsLoading(true))
    dispatch(listingsLoadingMessage('Combining new flight options...'))

    // Get updated filter object before making request
    const sliceSelectionFilters = flySliceSelectionStorage.getFiltersStorage()

    if (isSBS) {
      buildFlySearchDisplayFiltersObj({
        filter: filters,
        sliceSelectionFilters,
        isLoadMore: true,
        activeTabId: getState().activeTabId,
      })
    } else {
      buildFlySearchDisplayFilterObj({
        filter: filters,
        sliceSelectionFilters,
        isLoadMore: true,
      })
    }

    // eslint-disable-next-line consistent-return
    return airSearchGraphPromise()

    function logError(error, sliceLength) {
      window?.newrelic?.noticeError(error)
      flyGaLogic.fire.filteredResponse(
        error.code || error.errorCode,
        sliceLength
      )
    }

    function airSearchGraphPromise() {
      airSearch({
        pclnBootstrapData: PCLN_BOOTSTRAP_DATA,
        fromLoadMore: true,
      })
        .then(res => {
          const { response } = res

          const {
            requestId,
            lowerBound,
            upperBound,
            filteredCount,
            totalFilteredItineraries,
          } = response.listingsMetaData

          const currentListings = get(getState(), 'listings.response', [])
          const brandReference = get(response, 'brandReference', [])

          flyGaLogic.fire.viewMoreFlights(
            getPageNumber({
              itinerariesIndex: upperBound,
            })
          )

          const listings = currentListings.concat(response.listings)
          const loadMore = canLoadMoreitins(
            upperBound,
            totalFilteredItineraries
          )
          dispatch(displayInfiniteScrollLoadMore(loadMore))
          dispatch(listingsIsLoading(false))

          const listingsObj = {
            response: listings,
          }

          /**
           * Some of the meta data that was set on initial request need not be overridden,
           * Override the fields that are necessary
           **/
          const metaData = {
            requestId,
            lowerBound,
            upperBound,
            filteredCount,
          }

          dispatch(setListingsMetaData(metaData))
          dispatch(listingsLoadMoreSuccess(listingsObj))

          // Update Brand Reference
          if (
            brandReference?.length &&
            !isEqual(get(getState(), 'brandReference'), brandReference)
          ) {
            dispatch(updateBrandReference(brandReference))
          }
          dispatch(toggleLoadingOverlay(false))
        })
        .catch(error => {
          const sliceLength = airSearchRequestModel.slices.length

          logError(error, sliceLength)
          handleError(dispatch, error, 'LOAD_MORE')
        })
    }
  }
}
